export default "https://cdn-static.gokick.com/assets/ed6531e95fd3f911890bedfaed34e81f4e5a2128/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";